import { useEffect, useState, useCallback } from "react";
import getCookie from "../components/LanguageProvider/utils/cookies";
export default function useCookieConsent() {
    const [consent, setConsent] = useState(null);
    const parseCookieString = useCallback((cookieStr) => {
        const entries = cookieStr.split(",").map((pair) => pair.split(":"));
        const result = {};
        entries.forEach(([key, value]) => {
            if (key && value) {
                result[key.trim()] = value.trim();
            }
        });
        return result;
    }, []);
    const removeFunctionalCookies = useCallback(() => {
        ["movement", "language"].forEach((cookieName) => {
            document.cookie = `${cookieName}=; max-age=0; path=/`;
        });
    }, []);
    const applyConsentToAll = useCallback(() => {
        setConsent({
            action: "yes",
            advertisement: "yes",
            analytics: "yes",
            consent: "yes",
            functional: "yes",
            necessary: "yes",
            other: "yes",
            performance: "yes",
        });
    }, []);
    const denyConsentToAll = useCallback(() => {
        setConsent({
            action: "no",
            advertisement: "no",
            analytics: "no",
            consent: "no",
            functional: "no",
            necessary: "no",
            other: "no",
            performance: "no",
        });
    }, []);
    const processConsent = useCallback(() => {
        var _a;
        const cookie = getCookie("cookieyes-consent");
        if (!cookie) {
            if ((_a = window.Chuffed) === null || _a === void 0 ? void 0 : _a.isUkOrEu) {
                denyConsentToAll();
            }
            else {
                applyConsentToAll();
            }
            return;
        }
        try {
            const parsed = parseCookieString(cookie);
            if (parsed.functional === "no") {
                removeFunctionalCookies();
            }
            setConsent(parsed);
            // eslint-disable-next-line @typescript-eslint/no-unused-vars -- surfaced by ESLint 10 migration, flagged for follow-up
        }
        catch (err) {
            // if failed to parse Cookie consent cookie just assume consent
            applyConsentToAll();
        }
    }, [applyConsentToAll, denyConsentToAll, parseCookieString, removeFunctionalCookies, setConsent]);
    useEffect(() => {
        processConsent();
        // Listen for user updates
        const handleUpdate = () => {
            processConsent();
        };
        document.addEventListener("cookieyes_consent_update", handleUpdate);
        return () => document.removeEventListener("cookieyes_consent_update", handleUpdate);
    }, [processConsent]);
    const hasConsented = (category) => {
        if (!consent) {
            return false;
        }
        return consent[category] === "yes";
    };
    return { consent, hasConsented };
}
